import React, { useEffect, useRef } from 'react';

const Starfield = () => {
  const starfieldRef = useRef(null);

  useEffect(() => {
    const starfield = starfieldRef.current;
    if (!starfield) return;

    // Create stars
    const createStars = () => {
      const starCount = 200;
      
      for (let i = 0; i < starCount; i++) {
        const star = document.createElement('div');
        star.className = 'star';
        
        // Random position
        const x = Math.random() * 100;
        const y = Math.random() * 100;
        
        // Random size and opacity
        const size = Math.random() * 3 + 1;
        const opacity = Math.random() * 0.8 + 0.2;
        
        // Random animation delay
        const delay = Math.random() * 3;
        const duration = Math.random() * 2 + 2;
        
        star.style.cssText = `
          position: absolute;
          left: ${x}%;
          top: ${y}%;
          width: ${size}px;
          height: ${size}px;
          background: white;
          border-radius: 50%;
          opacity: ${opacity};
          animation: twinkle ${duration}s infinite ${delay}s;
          z-index: 1;
        `;
        
        starfield.appendChild(star);
      }
    };

    createStars();
  }, []);

  return (
    <div 
      ref={starfieldRef}
      className="starfield"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 1,
        overflow: 'hidden'
      }}
    />
  );
};

export default Starfield; 